import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Header from '../../../test/components/header/Header';
import Footer from '../../../test/components/footer/Footer';

import { useLocalStore, useStore } from '../../../../stores';
import { logoutIcon, nextIcon } from '../../../../utils/icons';

import styles from './RolePage.module.scss';
import User from '../../../../stores/models/User';

type LocalStore = {
    user: User | null,
};

export default observer(function RolePage() {
    const history = useHistory();

    const { authStore } = useStore();
    const { localStore } = useLocalStore<LocalStore>({
        user: authStore.user?.clone() || null,
    });

    useEffect(() => {
        localStore.user = authStore.user?.clone() || null;
    }, [authStore.user]);

    if (!localStore.user) {
        return (
            <div>Not found</div>
        );
    }

    if (!localStore.user.role) {
        localStore.user.role = 'players';
    }

    return (
        <div className={styles.container}>
            <div className={styles.top}>
                <Header
                    title="Choose your role"
                    left={null}
                    right={{
                        icon: logoutIcon,
                        onClick: () => authStore.logout(),
                    }}
                />

                {!authStore.user?.role && (
                    <div>
                        <ul className="progressbar">
                            <li className="active">Registered</li>
                            <li>Select role</li>
                            <li>Additional info</li>
                        </ul>
                    </div>
                )}

                <div className={styles.profileRole}>
                    <div
                        className={classNames(styles.profileRoleItem, {
                            [styles.profileRoleItemActive]: localStore.user.role === 'players',
                        })}
                        onClick={() => {
                            if (localStore.user) {
                                localStore.user.role = 'players';
                            }
                        }}
                    >
                        <img
                            className={styles.profileRoleItemBackground}
                            src={require('../../assets/images/player.png').default}
                            alt=""
                        />

                        <div className={styles.profileRoleItemFooter}>
                            Amateur
                            Player
                        </div>
                    </div>

                    <div
                        className={classNames(styles.profileRoleItem, {
                            [styles.profileRoleItemActive]: localStore.user.role === 'coaches',
                        })}
                        onClick={() => {
                            if (localStore.user) {
                                localStore.user.role = 'coaches';
                            }
                        }}
                    >
                        <img
                            className={styles.profileRoleItemBackground}
                            src={require('../../assets/images/coach.png').default}
                            alt=""
                        />

                        <div className={styles.profileRoleItemFooter}>
                            Professional
                            Coach
                        </div>
                    </div>

                    <div
                        className={classNames(styles.profileRoleItem, {
                            [styles.profileRoleItemActive]: localStore.user.role === 'courts',
                        })}
                        onClick={() => {
                            if (localStore.user) {
                                localStore.user.role = 'courts';
                            }
                        }}
                    >
                        <img
                            className={styles.profileRoleItemBackground}
                            src={require('../../assets/images/admin.png').default}
                            alt=""
                        />

                        <div className={styles.profileRoleItemFooter}>
                            Tennis Courts
                            Administrator
                        </div>
                    </div>
                </div>

                {localStore.user.role === 'players' && (
                    <div style={{ padding: 10 }}>
                        - Play whatever around the world. <br/>
                        - Invite your favourite players with specific criteria. <br/>
                        - Book your coach and courts on-line by 1 click. <br/>
                        - Don’t loose “hot deals” from coaches and courts. <br/>
                        - Keep all your game statistic in one place. <br/>
                        - Raise ELLO rating, etc.
                    </div>
                )}

                {localStore.user.role === 'coaches' && (
                    <div style={{ padding: 10 }}>
                        - Find new talent and rising stars around you! <br/>
                        - Manage your public calendar by a few clicks and do not be distracted from your daily job! <br/>
                        - Easily coordinate your training schedule, court and players.
                    </div>
                )}

                {localStore.user.role === 'courts' && (
                    <div style={{ padding: 10 }}>
                        - Get easy booking system for your courts! <br/>
                        - Get access to your local player and coach and raise your local community! <br/>
                        - Push promo and “hot ours” direct to your fans and never ever have empty courts!
                    </div>
                )}
            </div>

            <div className={styles.bottom}>
                <Footer
                    buttons={[
                        null,
                        null,
                        {
                            title: 'Next',
                            icon: nextIcon,
                            onClick: () => {
                                if (!authStore.user || !localStore.user) {
                                    return;
                                }

                                history.push('/profile/edit', {
                                    role: localStore.user.role,
                                });
                            },
                        },
                    ]}
                />
            </div>
        </div>
    );
});
